import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import Modal from 'react-modal';
import _ from 'lodash';
import AllInputs from '../../../../inputs/AllInputs';
import {
  lookupDepartmentByName,
  setCustomModalTab,
  addVehicleProperty,
  updateVehicleDepartment,
  processDepartments,
  vsearch,
} from '../../../../actions/apiDealerUpdates';

const CheckboxesTab = ({ tab, userStamp, vehicle_id }) => {
  const dispatch = useDispatch();

  // Select state from Redux
  const vehicle = useSelector((state) => state.settings_refresh.active_vehicle);
  const vehicle_properties = useSelector(
    (state) => state.settings_refresh.active_vehicle.vehicle_properties,
  );
  const installation = useSelector((state) => state.settings_dealerships.installation);
  const vehicle_columns = useSelector((state) => state.settings_departments.vehicle_columns);
  const current_user = useSelector((state) => state.current_user);

  // Local state for form inputs
  const [formData, setFormData] = useState({});

  // Handle input changes
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const tabData = _.find(useSelector((state) => state.settings_site.all_tabs), { name: tab }) || [];
  const tab_properties = tabData.tab_properties || [];

  // automax logic
  const is_automax = installation?.subdomain === 'automaxatlanta';
  let automax_all = null;

  if (is_automax) {
    const renderAutomaxSection = (array) =>
      array.map((tab_property) => {
        const vehicle_column = _.find(vehicle_columns, { name: tab_property.name }) || {};
        const colObject = _.find(vehicle_properties, { key: vehicle_column.name }) || {};

        if (!vehicle_column || Object.keys(vehicle_column).length === 0) {
          return null;
        }

        return (
          <span key={`automax_${vehicle.id}_${tab_property.name}`}>
            <label className="label checkboxes-tab-label text-capitalize fw-bold">
              {tab_property.name}
            </label>
            <AllInputs
              name={vehicle_column.name}
              label={vehicle_column.name}
              display_label_1={vehicle_column.display_label_1}
              display_label_2={vehicle_column.display_label_2}
              onChange={onChange}
              // onBlur assumed handled by AllInputs
              user_name={colObject.user_name}
              value={colObject.value || ''}
              type={vehicle_column.input_name}
              options={vehicle_column.options}
              checked={colObject.value || ''}
              updatetype="vehicleproperty"
              key={`vehicle_${vehicle.id}_tab_property_${colObject.id}`}
              parentid={vehicle.id}
              rowid={colObject.id || ''}
              uid={colObject.uid}
              updated_at={colObject.updated_at}
              icon={vehicle_column.icon}
              userStamp={userStamp}
              setdisabled={false}
              vehicle={vehicle}
            />
          </span>
        );
      });

    const wheel_array = [
      { name: 'wheel repair' },
      { name: 'Wheel Repair FL' },
      { name: 'Wheel Repair FR' },
      { name: 'Wheel Repair BL' },
      { name: 'Wheel Repair BR' },
    ];
    const tire_array = [
      { name: 'tires' },
      { name: 'tire size' },
      { name: 'Tires FL' },
      { name: 'Tires FR' },
      { name: 'Tires BL' },
      { name: 'Tires BR' },
    ];
    const interior_array = [
      { name: 'interior dye' },
      { name: 'driver seat only' },
      { name: 'overall interior' },
    ];
    const interior_array2 = [
      { name: 'interior repair' },
      { name: 'repair driver seat' },
      { name: 'repair passenger seat' },
      { name: 'repair other' },
    ];
    const pdr_array = [{ name: 'pdr' }, { name: 'pdr notes' }];
    const service_array = [{ name: 'service' }, { name: 'service notes' }];
    const refresh_array = [{ name: 'refresh' }, { name: 'refresh notes' }];

    automax_all = (
      <div className="row">
        <div className="card card-body">{renderAutomaxSection(wheel_array)}</div>
        <div className="card card-body">{renderAutomaxSection(tire_array)}</div>
        <div className="card card-body">{renderAutomaxSection(interior_array)}</div>
        <div className="card card-body">{renderAutomaxSection(interior_array2)}</div>
        <div className="card card-body">{renderAutomaxSection(pdr_array)}</div>
        <div className="card card-body">{renderAutomaxSection(service_array)}</div>
        <div className="card card-body">{renderAutomaxSection(refresh_array)}</div>
      </div>
    );
  }

  return (
    <div className="card col-md-6 offset-3 text-center">
      <div className="card-body checkboxes-tab">
        {tab_properties
          .filter((tab_property) => {
            const dealership = tab_property.dealership || '';
            const subdomain = installation?.subdomain;
            return !subdomain || dealership.split(',').includes(subdomain);
          })
          .map((tab_property) => {
            const vehicle_column =
              _.find(vehicle_columns, { id: tab_property.vehicle_column_id }) || {};

            if (
              installation?.subdomain?.includes('automaxatlanta') &&
              [
                'service',
                'tires',
                'wheel repair',
                'interior dye',
                'interior repair',
                'pdr',
                'refresh',
              ].includes(vehicle_column.name)
            ) {
              return null;
            }

            if (!vehicle_column || Object.keys(vehicle_column).length === 0) {
              return null;
            }

            const colObject = _.find(vehicle_properties, { key: vehicle_column.name }) || {};

            return (
              <span key={`tab_property_${tab_property.id}`}>
                <label className="label checkboxes-tab-label text-capitalize fw-bold">
                  {tab_property.name}
                </label>
                <AllInputs
                  name={vehicle_column.name}
                  label={vehicle_column.name}
                  display_label_1={vehicle_column.display_label_1}
                  display_label_2={vehicle_column.display_label_2}
                  onChange={onChange}
                  // onBlur assumed handled by AllInputs
                  user_name={colObject.user_name}
                  value={colObject.value || ''}
                  type={vehicle_column.input_name}
                  options={vehicle_column.options}
                  checked={colObject.value || ''}
                  parentid={vehicle_id}
                  rowid={colObject.id || ''}
                  uid={colObject.uid}
                  updated_at={colObject.updated_at}
                  updatetype="vehicleproperty"
                  icon={vehicle_column.icon}
                  userStamp={userStamp}
                  setdisabled={false}
                  vehicle={vehicle}
                />
              </span>
            );
          })}

        {is_automax && automax_all}
      </div>
      <div className="card-footer" />
    </div>
  );
};

export default CheckboxesTab;